<template>
  <div class="app-footer-menu">
    <div
      class="app-footer-menu__column"
      v-for="(group, group_index) in menuItems"
      :key="group_index"
    >
      <div class="app-footer-menu__title">{{ group.label }}</div>
      <ul class="app-footer-menu__group">
        <li class="app-footer-menu__link" v-for="(link, index) in group.links" :key="index">
          <router-link v-if="link.to" :to="link.to">
            {{ link.label }}
          </router-link>
          <a v-else-if="link.href" :href="link.href" :target="link.target" :rel="link.rel">
            {{ link.label }}
          </a>
          <!-- <template v-else-if="link.countrySelector">
            <CountrySelector v-if="!hideCountrySelector" />
          </template> -->

          <button v-else :class="link.className">
            {{ link.label }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CountrySelector from '@/components/CountrySelector/CountrySelector.vue';

const categoryTreeCountries = ['ae', 'id', 'za', 'my', 'sg', 'sa', 'gb', 'fr', 'de'];

export default {
  name: 'AppFooterMenu',
  components: { CountrySelector },
  computed: {
    ...mapGetters({
      navigationUrlList: 'navigationUrlList',
      isLoggedIn: 'user/isLoggedIn',
      countryBaseUrl: 'country/countryBaseUrl',
      masterClassLink: 'masterClass/link',
      masterClassLinkAvailable: 'masterClass/isAvailable',
      localeCountry: 'country/localeCountry',
    }),
    localeCountryCode() {
      if (this.localeCountry?.countryCode) {
        return this.localeCountry?.countryCode?.toLowerCase() || 'us';
      } else {
        return this.localeCountry.toLowerCase() || 'us';
      }
    },
    menuItems() {
      const { isLoggedIn, navigationUrlList, countryBaseUrl, translate } = this;
      return [
        {
          label: translate('Company'),
          links: [
            {
              label: translate('Customer reviews'),
              href: `${countryBaseUrl}reviews`,
              hidden: isLoggedIn,
            },
            {
              label: translate('Careers at JobLeads'),
              href: navigationUrlList.career,
              rel: 'noreferrer',
              target: '_blank',
            },
            {
              label: translate('Site notice'),
              href: `${countryBaseUrl}site-notice`,
            },
          ].filter((link) => !link.hidden),
        },
        {
          label: translate('Services'),
          links: [
            {
              label: translate('Free resume review'),
              href: isLoggedIn
                ? '/free-resume-review/report'
                : `${countryBaseUrl}free-resume-review`,
            },
            {
              label: translate('Job search'),
              href: '/search/jobs',
            },
            {
              label: translate('Headhunter matching'),
              href: `${countryBaseUrl}headhunters`,
              hidden: isLoggedIn,
            },
            {
              label: 'Career Advice',
              href: '/career-advice',
            },
            {
              label: translate('JobLeads MasterClass'),
              href: this.masterClassLink,
              hidden: !this.masterClassLinkAvailable,
            },
            {
              label: translate('Browse jobs'),
              href: `${countryBaseUrl}jobs`,
              hidden: isLoggedIn || !categoryTreeCountries.includes(this.localeCountryCode),
            },
          ].filter((link) => !link.hidden),
        },
        {
          label: translate('Free resources'),
          links: [
            {
              label: translate('Predictions for 2024'),
              href: '/career-advice/recruitment-trends-2024',
            },
            {
              label: translate('5 Stages of a Successful Job Search'),
              href: '/career-advice/5-phases-of-a-succesful-job-search-journey',
            },
            {
              label: translate('8 Common Job Search Mistakes'),
              href: '/career-advice/why-cant-I-find-a-job',
            },
            {
              label: translate('How Long should My Resume Be?'),
              href: '/career-advice/how-long-should-my-resume-be',
            },
          ].filter((link) => !link.hidden),
        },
        {
          label: translate('Support'),
          links: [
            {
              label: translate('Help'),
              href: navigationUrlList.support,
              rel: 'noreferrer',
              target: '_blank',
            },
            {
              label: translate('Cancel membership'),
              href: 'https://support.jobleads.com/hc/de/requests/new?ticket_form_id=16317432746642',
              rel: 'noreferrer',
              target: '_blank',
              hidden: isLoggedIn || !this.isGermanIp,
            },
            {
              label: translate('Partner integration'),
              href: `${countryBaseUrl}partner-integration`,
            },
            {
              label: translate('ATS Partners'),
              href: `${countryBaseUrl}ats-integration`,
            },
            {
              label: translate('Cookies'),
              className: 'ot-floating-button__open',
            },
            {
              label: translate('Privacy Policy'),
              href: `${countryBaseUrl}privacy-policy`,
            },
            {
              label: translate('Terms of Use'),
              href: `${countryBaseUrl}terms-of-use`,
            },
            // {
            //   countrySelector: true,
            // },
          ].filter((link) => !link.hidden),
        },
      ];
    },
    hideCountrySelector() {
      const { campaignId } = this.$route.params;
      return ['70'].includes(campaignId) || this.$route.name === 'registration-job';
    },
    isGermanIp() {
      return this.localeCountryCode === 'de';
    },
  },
};
</script>

<style lang="scss">
@import './AppFooterMenu.scss';
</style>
